import {
  ROLE_FILTER_ADDED,
  ROLE_FILTER_REMOVED,
  STATUS_FILTER_CHANGED,
  QUERY_CHANGED,
  SORT_TOGGLED,
  CLEAR_FILTERS,
  NAMES_AND_EMAILS_FILTER_CHANGED
} from '../actions/action-types';
import { SortDirection, MembersTableState, MembersColumnTypes } from '../../common/types';

type MembersTableAction = {
  type: string;
  value: string;
};

const initialState: MembersTableState = { filters: { roles: [], status: null, namesAndEmails: '' }, query: null, sort: { column: MembersColumnTypes.NAME, direction: SortDirection.asc } };

export const membersTable = (state: MembersTableState = initialState, action: MembersTableAction) => {
  switch (action.type) {
    case ROLE_FILTER_ADDED:
      if (Array.isArray(action.value)) {
        return { ...state, filters: { ...state.filters, roles: [] } };
      }
      return { ...state, filters: { ...state.filters, roles: state.filters.roles.filter(roleKey => roleKey !== action.value) } };
    case ROLE_FILTER_REMOVED:
      if (Array.isArray(action.value)) {
        return { ...state, filters: { ...state.filters, roles: action.value } };
      }
      return { ...state, filters: { ...state.filters, roles: [].concat(state.filters.roles, action.value) } };
    case STATUS_FILTER_CHANGED:
      return { ...state, filters: { ...state.filters, status: action.value } };
    case QUERY_CHANGED:
      return { ...state, query: action.value };
    case SORT_TOGGLED:
      const direction = state.sort.direction === SortDirection.asc && state.sort.column === action.value ? SortDirection.desc : SortDirection.asc;
      return { ...state, sort: { column: action.value, direction } };
    case CLEAR_FILTERS:
      return { filters: { roles: [], status: null, namesAndEmails: '' }, query: null, sort: { column: null, direction: null } };
    case NAMES_AND_EMAILS_FILTER_CHANGED:
      return { ...state, filters: { ...state.filters, namesAndEmails: action.value } };
    default:
      return state;
  }
};
